// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Scrollarea_scrollContainer__hBUq7 {
  scrollbar-width:none; /* Firefox */
}

.Scrollarea_scrollContainerforDashboard__P9z\\+K {
  scrollbar-width:thin; /* Firefox */
}

.Scrollarea_scrollContainer__hBUq7::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.Scrollarea_scrollContainer__hBUq7::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}

.Scrollarea_scrollContainerForTransaction__na7Nh::-webkit-scrollbar {
  width: 8px; /* Width of vertical scrollbar */
  height: 8px; /* Height of horizontal scrollbar (if needed) */
}

/* .scrollContainerForTransaction::-webkit-scrollbar-track {
  background-color: white;
  border-radius: 10px;
}  */

.Scrollarea_scrollContainerForTransaction__na7Nh::-webkit-scrollbar-thumb {
  background-color: #85898e; 
  border-radius: 10px;
  border: 2px solid #f0f0f0; 
}

/* .scrollContainerForTransaction::-webkit-scrollbar-thumb:hover {
  background-color: #357ABD; 
} */


`, "",{"version":3,"sources":["webpack://./src/components/vendorWebFolder/Scrollarea.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB,EAAE,YAAY;AACpC;;AAEA;EACE,oBAAoB,EAAE,YAAY;AACpC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,UAAU,EAAE,gCAAgC;EAC5C,WAAW,EAAE,+CAA+C;AAC9D;;AAEA;;;IAGI;;AAEJ;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;GAEG","sourcesContent":[".scrollContainer {\n  scrollbar-width:none; /* Firefox */\n}\n\n.scrollContainerforDashboard {\n  scrollbar-width:thin; /* Firefox */\n}\n\n.scrollContainer::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n.scrollContainer::-webkit-scrollbar-button {\n  display: none;\n  width: 0;\n  height: 0;\n}\n\n.scrollContainerForTransaction::-webkit-scrollbar {\n  width: 8px; /* Width of vertical scrollbar */\n  height: 8px; /* Height of horizontal scrollbar (if needed) */\n}\n\n/* .scrollContainerForTransaction::-webkit-scrollbar-track {\n  background-color: white;\n  border-radius: 10px;\n}  */\n\n.scrollContainerForTransaction::-webkit-scrollbar-thumb {\n  background-color: #85898e; \n  border-radius: 10px;\n  border: 2px solid #f0f0f0; \n}\n\n/* .scrollContainerForTransaction::-webkit-scrollbar-thumb:hover {\n  background-color: #357ABD; \n} */\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollContainer": `Scrollarea_scrollContainer__hBUq7`,
	"scrollContainerforDashboard": `Scrollarea_scrollContainerforDashboard__P9z+K`,
	"scrollContainerForTransaction": `Scrollarea_scrollContainerForTransaction__na7Nh`
};
export default ___CSS_LOADER_EXPORT___;
